// extracted by mini-css-extract-plugin
export var flex = "techInfo-module--flex--2dGfs";
export var item = "techInfo-module--item--3c_nR";